import  { useEffect, useState, Suspense, useRef } from "react";
import { TransitionGroup, CSSTransition } from "react-transition-group";
import Img from "../assets/images/img-register.png";
import Grid from "@material-ui/core/Grid";
import useStyles from "../assets/styles/styles";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Backdrop,
  CircularProgress,
  FormControl,
  FormHelperText,
  IconButton,
  Portal,
  Typography,
  Box
} from "@material-ui/core";
import Logo from "../assets/images/logo.png";
import whiteLogo from "../assets/images/whiteLogo.png";
import CustomizedInputs from "../controls/InputCustom/CustomizedInputs";
import CustomButton from "../controls/Button/CustomButton";
import {
  getDataRegisterUser,
  registerUser,
  verifyRegister,
  verifyRegisterMedical,
  verifyTypeOfUser,
} from "../redux/actions/registerUsersActions";
import { useDispatch, useSelector } from "react-redux";
import CustomSelect from "../controls/Select/CustomSelect";
import CustomDatePicker from "../controls/DatePicker/CustomizedDatePicker";
import {  validate } from "./UtilsFunctions";
import LoadingPage from "../components/LoadingPage/LoadingPage";
import { updateTag } from "../redux/actions/personPlayerActions";
import { useResizeScreen } from "../hooks/useResizeScreen";
import HomeIcon from "@material-ui/icons/Home";
import clsx from "clsx";
import { useHistory } from "react-router-dom";
import { format } from "date-fns";
import { showMessageModal } from "../utils/utilsFunctions";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";

const Register = () => {
  const listType = [
    { value: "DNI", label: "DNI" },
    { value: "CIL", label: "C.U.I.L" },
    { value: "CUI", label: "C.U.I.T" },
    { value: "CI", label: "Cédula de Identidad" },
    { value: "DU", label: "Documento único" },
    { value: "E/T", label: "En trámite" },
    { value: "LC", label: "Libreta Cívica (Sólo sexo Femenino)" },
    { value: "LE", label: "Libreta Enrolamiento (Sólo sexo Masculino)" },
    { value: "PAS", label: "Pasaporte" },
    { value: "OTR", label: "Otros" },
  ];

  const userTypeList = [
    { value: "AFILIADO", label: "AFILIADO" },
    { value: "MEDICO", label: "MEDICO" },
    { value: "AFILIADO-MEDICO", label: "AMBOS" },
  ];

  const externalUserTypeList = [
    { value: "EXTERNO", label: "EXTERNO" },
    { value: "MEDICO", label: "MEDICO" },
    { value: "EXTERNO-MEDICO", label: "AMBOS" },
  ];

  const classes = useStyles();
  const dispatch = useDispatch();
  const [typesDocument, setTypesDocument] = useState([]);
  const [type, setType] = useState("");
  const [userTypeSelection, setUserTypeSelection] = useState("");
  const [birthDate, setbirthDate] = useState(new Date());
  const [dni, setDni] = useState("");
  const [credential, setCredential] = useState("");
  const [enrollment, setEnrollment] = useState("");
  const { screen } = useResizeScreen();
  const userData = useSelector((state) => state.registerUsersReducer.dataUser);
  const loginValidation = useSelector(
    (state) => state.registerUsersReducer.registerValidation
  );
  const userTypeValidation = useSelector(
    (state) => state.registerUsersReducer.userTypeValidation
  );

  const campoObligatorio = "*Campo obligatorio";

  const [personalDataErrors, setPersonalDataErrors] = useState({
    parameterType: campoObligatorio,
    document: campoObligatorio,
    birthDate: campoObligatorio,
  });

  const [aditionalDataErrors, setAditionalDataErrors] = useState({
    credential:
      userTypeValidation?.perfil?.trim() == "AFILIADO" ||
      userTypeValidation?.perfil?.trim() == "AFILIADO-MEDICO" ||
      userTypeValidation?.perfil?.trim() == "EXTERNO" ||
      userTypeValidation?.perfil?.trim() == "EXTERNO-MEDICO"
        ? campoObligatorio
        : "",
    enrollment:
      userTypeValidation?.perfil?.trim() == "MEDICO" ||
      userTypeValidation?.perfil?.trim() == "AFILIADO-MEDICO"||
      userTypeValidation?.perfil?.trim() == "EXTERNO-MEDICO"
        ? campoObligatorio
        : "",
    userTypeSelection:
      userTypeValidation?.perfil?.trim() == "AFILIADO-MEDICO"
        ? campoObligatorio
        : "",
  });

 
  const registerReduxState = useSelector((state) => state.registerUsersReducer);
  const [loading, setLoading] = useState(true);
  const [initialLoad, setInitialLoad] = useState(true);
  const history = useHistory();
  const [errorMessageModal, setErrorMessageModal] = useState(false);
  const errorMessage = useSelector(
    (state) => state.registerUsersReducer.msgError
  );
  const [isPersonalDataExpanded, setIsPersonalDataExpanded] = useState(true);
  const [isAditionalDataExpanded, setIsAditionalDataExpanded] = useState(true);

  const personalDataRef = useRef(null);
  const [editDateBirth, setEditDateBirth] = useState(false);


  const [showAditionalDataAccordion, setShowAditionalDataAccordion] =
    useState(false);

  const handlePersonalDataChange = (event, isExpanded) => {
    setIsPersonalDataExpanded(isExpanded);
  };

  const handleAditionalDataChange = (event, isExpanded) => {
    if (isExpanded) {
      setIsPersonalDataExpanded(false);
    }
    setIsAditionalDataExpanded(isExpanded);
  };


  useEffect(() => {
    if (
      userTypeValidation?.perfil?.trim() == "AFILIADO" ||
      userTypeValidation?.perfil?.trim() == "MEDICO" ||
      userTypeValidation?.perfil?.trim() == "AFILIADO-MEDICO" ||
      userTypeValidation?.perfil?.trim() == "EXTERNO" ||
      userTypeValidation?.perfil?.trim() == "EXTERNO-MEDICO"
    ) {
      setShowAditionalDataAccordion(true);
      setIsPersonalDataExpanded(false);
      if (userTypeValidation?.perfil?.trim() == "AFILIADO-MEDICO") {
        if (credential && enrollment) {
          setCurrentProfile("AFILIADO");
        } else if (credential && !enrollment) {
          setCurrentProfile("AFILIADO");
        } else if (!credential && enrollment) {
          setCurrentProfile("MEDICO");
        }
      }
    }
  }, [userTypeValidation?.perfil]);

  

  const isPersonalDataValidForm = () =>
    Object.values(personalDataErrors).every((x) => x === "");

  const isAditionalDataValidForm = () =>
    Object.values(aditionalDataErrors).every((x) => x === "");

  const handleRegister = () => {
    if (isAditionalDataValidForm()) {
      const email = window.localStorage.getItem("email");
      let request = {
        mail: email,
        tipoRegistracion: userTypeSelection,
        telefono: "",
        tipoDocumento: type,
        nroDocumento: dni,
        nroCredencial: userTypeSelection === "EXTERNO" || userTypeSelection === "EXTERNO-MEDICO"
                      ? ""
                      : credential,
        fechaNacimiento: format(birthDate, "yyyy-MM-dd"),
        matricula: enrollment,
      };

      dispatch(registerUser(request));
      setLoading(true);
      dispatch(getDataRegisterUser({ mail: email }));
    }
  };

  useEffect(() => {
    if (userTypeValidation?.perfil?.trim()) {
      setUserTypeSelection(userTypeValidation.perfil.trim());
    }
  }, [userTypeValidation?.perfil]);
  
  const handleVerifyTypeOfUser = () => {
    if (isPersonalDataValidForm()) {
      let request = {
        tipoDocumento: type,
        nroDocumento: dni,
        fechaNacimiento: format(birthDate, "yyyy-MM-dd"),
      };
      window.localStorage.setItem("tipoDocumento", request.tipoDocumento);
      window.localStorage.setItem("nroDocumento", request.nroDocumento);
      window.localStorage.setItem("fechaNacimiento", request.fechaNacimiento);
  
      dispatch(verifyTypeOfUser(request));
    }
  };

  const handleChangeDNIType = (e) => {
    e.preventDefault();
    const { name, value } = e.target;
    setType(value);
    validate(
      name,
      "*Campo obligatorio",
      value,
      setPersonalDataErrors,
      personalDataErrors
    );
    setDni("");
    setCredential("");
    setPersonalDataErrors({
      ...personalDataErrors,
      document: campoObligatorio,
      parameterType: "",
    });
  };

  const handleChangeUserType = (e) => {
    e.preventDefault();
    const { name, value } = e.target;
    setUserTypeSelection(value);
    validate(
      name,
      "*Campo obligatorio",
      value,
      setAditionalDataErrors,
      aditionalDataErrors
    );
    setEnrollment("");
    setCredential("");
    setAditionalDataErrors({
      ...aditionalDataErrors,
      userTypeSelection: "",
      credential:
        value == "AFILIADO" || value == "AMBOS" ? campoObligatorio : "",
      enrollment: value == "MEDICO" || value == "AMBOS" ? campoObligatorio : "",
    });
  };

  useEffect(() => {
    if (userTypeValidation?.perfil?.trim()?.toUpperCase() === "AMBOS") {
      setUserTypeSelection("AMBOS");
    }
  }, [ userTypeValidation?.perfil]);


  useEffect(() => {
    if (birthDate == null || birthDate == "Invalid Date") {
      setPersonalDataErrors({
        ...personalDataErrors,
        birthDate: "*Fecha inválida",
      });
    } else {
      setPersonalDataErrors({
        ...personalDataErrors,
        birthDate: "",
      });
    }
  }, [birthDate]);

  const validateSpecialCaracters = (dniNumber) => {
    if (type === "DNI") {
      return validateOnlyNumbers(dniNumber);
    } else {
      return dniNumber?.match(/^[a-zA-Z0-9]*$/);
    }
  };

  const validateOnlyNumbers = (credentialNumber) => {
    return credentialNumber?.match(/^\d*$/);
  };

  const handleChangeDNI = (e) => {
    e.preventDefault();
    setDni(e.target.value);
  };

  const handleOnBlurDNI = () => {
    validate(
      "document",
      campoObligatorio,
      dni,
      setPersonalDataErrors,
      personalDataErrors
    );
    type === "DNI" &&
      dni?.length > 8 &&
      setPersonalDataErrors({
        ...personalDataErrors,
        document: "*El campo debe tener como máximo 8 caracteres",
      });
    type !== "DNI" &&
      dni?.length > 15 &&
      setPersonalDataErrors({
        ...personalDataErrors,
        document: "*El campo debe tener como máximo 15 caracteres",
      });
    !validateSpecialCaracters(dni) &&
      setPersonalDataErrors({
        ...personalDataErrors,
        document: "El campo no debe tener carácteres especiales",
      });
  };

  const handleChangeCredential = (e) => {
    e.preventDefault();
    setCredential(e.target.value);
  };

  const handleOnBlurCredential = () => {
    validate(
      "credential",
      campoObligatorio,
      credential,
      setAditionalDataErrors,
      aditionalDataErrors
    );
    credential?.length > 40 &&
      setAditionalDataErrors({
        ...aditionalDataErrors,
        credential: "*El campo debe tener como máximo 40 caracteres",
      });
    !validateOnlyNumbers(credential) &&
      setAditionalDataErrors({
        ...aditionalDataErrors,
        credential: "*El campo debe tener sólo números",
      });
  };

  const handleChangeEnrollment = (e) => {
    e.preventDefault();
    setEnrollment(e.target.value);
  };

  const handleOnBlurEnrollment = () => {
    validate(
      "enrollment",
      campoObligatorio,
      enrollment,
      setAditionalDataErrors,
      aditionalDataErrors
    );
    enrollment?.length > 6 &&
      setAditionalDataErrors({
        ...aditionalDataErrors,
        enrollment: "*El campo debe tener como máximo 6 números",
      });
    !validateOnlyNumbers(enrollment) &&
      setAditionalDataErrors({
        ...aditionalDataErrors,
        enrollment: "*El campo debe tener sólo números",
      });
  };

  useEffect(() => {
    let param = {};
    param.Email = window.localStorage.getItem("email");

    dispatch(getDataRegisterUser(param));
    setTypesDocument(listType);

    if (history.location.pathname === "/Register") {
      document.getElementById("root").className = "";
    } else {
      document.getElementById("root").className = "content";
    }
  }, []);

  useEffect(() => {
    window.localStorage.setItem("registerFlag", "Registrando");
  }, []);

  useEffect(() => {
   
    if (loading && registerReduxState?.registerUser?.confirmacion) {
      let data = {
        mail: window.localStorage.getItem("email"),
      };

      const perfil = userTypeValidation?.perfil?.trim()?.toUpperCase();

      if (
        perfil === "AFILIADO" ||
        (perfil === "AFILIADO-MEDICO" && credential) ||
        (perfil === "EXTERNO" && !credential) ||
        (perfil === "EXTERNO-MEDICO" && userTypeSelection === "EXTERNO") ||
        (perfil === "EXTERNO-MEDICO" && userTypeSelection === "EXTERNO-MEDICO")
      ) {
        dispatch(verifyRegister(data));
      } else if (
        perfil === "AFILIADO-MEDICO" ||
        (perfil === "MEDICO" && !credential)||
        (perfil === "EXTERNO-MEDICO" &&  userTypeSelection === "MEDICO")
      ) {
        dispatch(verifyRegisterMedical(data));
      }
    }
  }, [userTypeValidation?.perfil, registerReduxState?.registerUser?.confirmacion]);

  useEffect(() => {
    const { registerValidation, registerMedicalValidation } = registerReduxState || {};
    const { dataUser } = registerReduxState || {};

    const isRegistered =
      loading &&
      ((registerValidation?.confirmacion && registerValidation?.estado !== "BAJA") ||
        (registerMedicalValidation?.confirmacion && registerMedicalValidation?.estado !== "BAJA"));

    if (isRegistered) {
      window.localStorage.setItem("registerFlag", "Registrado");
      window.localStorage.setItem("expired", "false");
      window.localStorage.setItem("dataUser", dataUser?.dataUser);   
      const numeroPersona = registerValidation?.numeroPersona || registerMedicalValidation?.numeroPersona;
      if (numeroPersona) {
        window.localStorage.setItem("numeroPersona", numeroPersona);
      }
      const playerId = window.localStorage.getItem("playerId");
      const user = window.localStorage.getItem("email");
      const perfil = userTypeValidation?.perfil?.trim()?.toUpperCase();
      const userDataCredential = registerReduxState?.dataUser.credential;
      const activeStatus = registerValidation?.estado?.trim()?.toUpperCase() === "ACTIVO";

      const userCredential = credential != "" ? credential : userDataCredential;

      dispatch(updateTag({ user: user, playerId: playerId, action: "LOGOUT" }));

      const showRedirectHome =
        activeStatus &&
        (perfil === "AFILIADO" ||
          (perfil === "AFILIADO-MEDICO" && userCredential) ||
          perfil === "EXTERNO" ||
          (perfil === "EXTERNO-MEDICO" && userTypeSelection !== "MEDICO"|| perfil === "EXTERNO-MEDICO" && userTypeSelection === "EXTERNO"));

      const showRedirectMedicalProfile =
        (perfil === "AFILIADO-MEDICO" && !userCredential) ||
        perfil === "MEDICO" ||
        (perfil === "EXTERNO-MEDICO" && userTypeSelection === "MEDICO");

      if (showRedirectHome) {
        window.location.replace("/");
      } else if (showRedirectMedicalProfile) {
        window.location.replace("/MedicalProfile");
      }
    }
  }, [registerReduxState?.registerValidation, registerReduxState?.registerMedicalValidation, userTypeValidation?.perfil]);

  const handleLogout = () => {
    setErrorMessageModal(false);
    setLoading(false)
    history.push("/logout");
    window.localStorage.clear();
  };

  useEffect(() => {
    let timer;
    const message = typeof errorMessage === 'string' ? errorMessage : String(errorMessage || '');
    if (message?.length > 0 && !message.toLowerCase().includes('postafiliadomedicovalidar')) {
      timer = setTimeout(() => {
        if (message?.length > 0) {
          setErrorMessageModal(true);
          setIsPersonalDataExpanded(true);
          setIsAditionalDataExpanded(false);
          setEditDateBirth(true);


          if (personalDataRef.current) {
            personalDataRef.current.scrollIntoView({ behavior: "smooth" });
          }
        }
      }, 3000);
    } else {
      setErrorMessageModal(false);
      setEditDateBirth(false);
    }
    return () => clearTimeout(timer);
  }, [errorMessage]);




  useEffect(() => {
    const mail = window.localStorage.getItem("email");

    if (userData !== null) {
      let data = {
        mail: mail,
      };
      if (userData !== "") {
        dispatch(verifyRegister(data));
        dispatch(verifyTypeOfUser(data));
      } else {
        setLoading(false);
      }
    }
  }, [userData]);

  useEffect(() => {
    if (!registerReduxState?.isLoading && !initialLoad) {
      setTimeout(() => {
        if (!errorMessage?.length) {
          setLoading(false);
        }
      }, 2000);
    }
    setInitialLoad(false);
  }, [registerReduxState?.isLoading]);

  const logoToReturn = () => {
    let logoToShow;
    if (screen.sWidth > 920) {
      logoToShow = (
        <img
          src={Logo}
          alt="logo Luis Pasteur"
          className={classes.logoPageLogin}
          style={{ marginRight: screen.sWidth > 768 && "25%" }}
        />
      );
    } else {
      logoToShow = (
        <img
          src={whiteLogo}
          alt="logo Luis Pasteur"
          style={{
            width: screen.sWidth > 768 ? "40%" : "60%",
            position: "absolute",
            top: "0",
            right: screen.sWidth > 768 ? "30%" : "22%",
          }}
        />
      );
    }
    return logoToShow;
  };

  

  const renderCredentialInput = () => {
    return (
      <>
        <FormControl className={` ${classes.inputLogin} `} variant="standard">
          <CustomizedInputs
            name="credential"
            label="NUMERO DE CREDENCIAL"
            value={credential}
            onChange={handleChangeCredential}
            onBlur={handleOnBlurCredential}
          />
        </FormControl>
        <FormHelperText
          style={{
            marginTop: "5px",
            color: screen.sWidth < 960 ? "white" : "#00000099",
          }}
          className={` ${classes.registerHelperText} `}
        >
          Son 11 números sin espacios, agregá ceros adelante si tenés menos
        </FormHelperText>
        <FormHelperText className={` ${classes.registerErrorText} `}>
          {aditionalDataErrors?.credential}
        </FormHelperText>
      </>
    );
  };

  const renderEnrollmentInput = () => {
    return (
      <>
        <FormControl className={` ${classes.inputLogin} `} variant="standard">
          <CustomizedInputs
            name="enrollment"
            label="NUMERO DE MATRICULA"
            value={enrollment}
            onChange={handleChangeEnrollment}
            onBlur={handleOnBlurEnrollment}
          />
        </FormControl>
        <FormHelperText
          style={{
            marginTop: "5px",
            color: screen.sWidth < 960 ? "white" : "#00000099",
          }}
          className={` ${classes.registerHelperText} `}
        >
          Max 6 números sin espacios
        </FormHelperText>
        <FormHelperText className={` ${classes.registerErrorText} `}>
          {aditionalDataErrors?.enrollment}
        </FormHelperText>
      </>
    );
  };


  const renderExternalInput = () => {
    return (
      <>
        <FormControl
          className={`${classes.inputLogin} ${classes.formControlDatePicker}`}
          variant="standard"
        >
          <CustomDatePicker
            onChange={setbirthDate}
            customRequired={true}
            value={birthDate}
            label="FECHA DE NACIMIENTO"
          />
        </FormControl>
      </>
    );
  };


  const renderExternalMedicalInput = () => {
    return (
      <>
        <FormControl
          className={`${classes.inputLogin} ${classes.formControlCustomSelect}`}
          variant="standard"
        >
          <CustomSelect
            name="externalUserTypeList"
            customRequired={true}
            list={externalUserTypeList}
            selected={userTypeSelection}
            onChange={handleChangeUserType}
            label="SELECCIONA UN PERFIL"
          />
        </FormControl>

        {(userTypeSelection === "EXTERNO" || userTypeSelection === "EXTERNO-MEDICO") && (
          <FormControl
            className={`${classes.inputLogin} ${classes.formControlDatePicker}`}
            variant="standard"
          >
            <CustomDatePicker
              onChange={setbirthDate}
              customRequired={true}
              value={birthDate}
              label="FECHA DE NACIMIENTO"
            />
          </FormControl>
        )}

        {(userTypeSelection === "MEDICO" || userTypeSelection === "EXTERNO-MEDICO") && (
          <FormControl className={` ${classes.inputLogin} `} variant="standard">
            <CustomizedInputs
              name="enrollment"
              label="NUMERO DE MATRICULA"
              value={enrollment}
              onChange={handleChangeEnrollment}
              onBlur={handleOnBlurEnrollment}
            />
          </FormControl>
        )}

        {userTypeSelection !== "EXTERNO" && (
          <>
            <FormHelperText
              style={{
                marginTop: "5px",
                color: screen.sWidth < 960 ? "white" : "#00000099",
              }}
              className={` ${classes.registerHelperText} `}
            >
              Max 6 números sin espacios
            </FormHelperText>
            <FormHelperText className={` ${classes.registerErrorText} `}>
              {aditionalDataErrors?.enrollment}
            </FormHelperText>
          </>
        )}
      </>
    );
  };


  const renderInputsBasedOnUserType = () => {
    switch (userTypeSelection) {
      case "AFILIADO":
        return renderCredentialInput();

      case "MEDICO":
        return renderEnrollmentInput();

      case "EXTERNO":
        return renderExternalInput();

      case "EXTERNO-MEDICO":
        return renderExternalMedicalInput();

      case "AFILIADO-MEDICO":
        return (
          <>
            {renderCredentialInput()}
            {renderEnrollmentInput()}
          </>
        );

      default:
        return null;
    }
  };

  const aditionalDataToShow = (typeOfUser) => {
    let component;

    if (typeOfUser == "AFILIADO") {
      component = renderCredentialInput();
    }

    if (typeOfUser == "MEDICO") {
      component = renderEnrollmentInput();
    }

    if (typeOfUser == "EXTERNO") {
      component = renderExternalInput();
    }

    if (typeOfUser == "EXTERNO-MEDICO") {
      component = renderExternalMedicalInput();
    }

    if (typeOfUser == "AFILIADO-MEDICO") {
      component = (
        <>
          <FormControl
            className={`${classes.inputLogin} ${classes.formControlCustomSelect} ${classes.formControlDatePicker}`}
            variant="standard"
          >
            <CustomSelect
              className={`${classes.selectDniLogin}`}
              name="userTypeList"
              customRequired={true}
              list={userTypeList}
              selected={userTypeSelection}
              onChange={handleChangeUserType}
              label="ELEGI UNA OPCION"
            />
          </FormControl>
          <FormHelperText className={` ${classes.registerErrorText} `}>
            {aditionalDataErrors?.userTypeSelection}
          </FormHelperText>
          {renderInputsBasedOnUserType()}
        </>
      );
    }

    return component;
  };

  return (
    <>
      {loading || loginValidation?.estado !== undefined ? (
        <Box
          className={`${classes.boxPointsDrawer} ${classes.centeredBox} ${classes.circularProgress}`}
        >
          <TransitionGroup>
            <CSSTransition timeout={500} classNames={{ ...loading }}>
              <Suspense fallback={<LoadingPage />}></Suspense>
            </CSSTransition>
          </TransitionGroup>
        </Box>
      ) : (
        <>
          <Box className={`${classes.root}`}>
            <Grid container className={`${classes.contentRegister}`}>
              <Grid item md={6} className={`${classes.marginn0}`}>
                <img
                  src={Img}
                  className={`${classes.registerImg}`}
                  alt="Obra Social Luis Pasteur"
                />
              </Grid>
              <Grid
                item
                md={6}
                className={`${classes.boxUsefulPhones} ${classes.boxUsefulPhones2}`}
              >
                <Box
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <IconButton
                    color="inherit"
                    maria-label="open drawer"            
                    edge="start"
                    className={clsx(classes.homeRegisterButton, open)}
                  >
                    <HomeIcon />
                  </IconButton>
                  {logoToReturn()}
                </Box>
                <Typography
                  className={classes.registerTitle}
                  style={{ marginTop: screen.sWidth >= 768 ? "5px" : "" }}
                >
                  Crear Cuenta
                </Typography>
                <Box style={{ padding: "5px" }}>
                  <Accordion
                    ref={personalDataRef} 
                    sx={{ boxShadow: "none", backgroundColor: "transparent" }}
                    expanded={isPersonalDataExpanded}
                    onChange={handlePersonalDataChange}
                  >
                    <AccordionSummary
                      expandIcon={
                        <ExpandMoreIcon
                          sx={{ color: screen.sWidth < 960 && "#fff" }}
                        />
                      }
                      aria-controls="panel1a-content"
                      id="panel1a-header"
                    >
                      <Typography sx={{ color: screen.sWidth < 960 && "#fff" }}>
                        DATOS PERSONALES
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Grid>
                        <FormControl
                          className={`${classes.inputLogin} ${classes.formControlCustomSelect} ${classes.formControlDatePicker}`}
                          variant="standard"
                        >
                          <CustomSelect
                            className={`${classes.selectDniLogin}`}
                            name="parameterType"
                            customRequired={true}
                            list={typesDocument}
                            selected={type}
                            onChange={handleChangeDNIType}
                            label="TIPO DE DOCUMENTO"
                            disabled={showAditionalDataAccordion ? true : false}
                          />
                        </FormControl>
                        <FormHelperText
                          className={` ${classes.registerErrorText} `}
                        >
                          {personalDataErrors?.parameterType}
                        </FormHelperText>
                        <FormControl
                          className={`${classes.inputLogin}`}
                          variant="standard"
                        >
                          <CustomizedInputs
                            name="document"
                            type="text"
                            label="NUMERO DE DOCUMENTO"
                            value={dni}
                            onChange={handleChangeDNI}
                            onBlur={handleOnBlurDNI}
                            disabled={showAditionalDataAccordion ? true : false}
                          />
                        </FormControl>
                        <FormHelperText
                          style={{
                            marginTop: "5px",
                            color: screen.sWidth < 960 ? "white" : "#00000099",
                          }}
                          className={` ${classes.registerHelperText} `}
                        >
                          {type === "DNI" || type === ""
                            ? "Son máximo 8 números sin espacios ni puntos"
                            : "Son máximo 15 caracteres sin espacios ni puntos"}
                        </FormHelperText>
                        <FormHelperText
                          className={` ${classes.registerErrorText} `}
                        >
                          {personalDataErrors?.document}
                        </FormHelperText>

                        <FormControl
                          className={`${classes.inputLogin} ${classes.formControlDatePicker}`}
                          variant="standard"
                        >
                          <CustomDatePicker
                            onChange={setbirthDate}
                            customRequired={true}
                            value={birthDate}
                            label="FECHA DE NACIMIENTO"
                            disable={!editDateBirth && showAditionalDataAccordion ? true : false}
                          />
                        </FormControl>
                        <FormHelperText
                          className={` ${classes.registerErrorText} `}
                        >
                          {personalDataErrors?.birthDate}
                        </FormHelperText>
                      </Grid>
                    </AccordionDetails>
                  </Accordion>

                  {showAditionalDataAccordion && (
                    <Accordion
                      sx={{ boxShadow: "none", backgroundColor: "transparent" }}
                      expanded={isAditionalDataExpanded}
                      onChange={handleAditionalDataChange}
                    >
                      <AccordionSummary
                        expandIcon={
                          <ExpandMoreIcon
                            sx={{ color: screen.sWidth < 960 && "#fff" }}
                          />
                        }
                        aria-controls="panel1a-content"
                        id="panel1a-header"
                      >
                        <Typography
                          sx={{ color: screen.sWidth < 960 && "#fff" }}
                        >
                          DATOS ADICIONALES
                        </Typography>
                      </AccordionSummary>
                      <AccordionDetails>
                        {aditionalDataToShow(
                          userTypeValidation?.perfil?.trim()
                        )}
                      </AccordionDetails>
                    </Accordion>
                  )}
                </Box>

                <Grid className={classes.flexRowBtnLogin}>
                  {!showAditionalDataAccordion ? (
                    <CustomButton
                      title="VALIDAR"
                      disabled={!isPersonalDataValidForm()}
                      customClass={`${classes.lightLinearGradient}`}
                      onClick={handleVerifyTypeOfUser}
                      style={{
                        marginTop: "15px",
                        fontSize: "12px",
                        padding: "9px 12px",
                      }}
                    />
                  ) : (
                    <CustomButton
                      title="CREAR CUENTA"
                      disabled={!isAditionalDataValidForm()}
                      customClass={`${classes.lightLinearGradient}`}
                      onClick={handleRegister}
                      style={{
                        marginTop: "15px",
                        fontSize: "12px",
                        padding: "9px 12px",
                      }}
                    />
                  )}
                </Grid>
              </Grid>
            </Grid>
          </Box>

         
        </>
      )}

      {showMessageModal(
        errorMessage,
        errorMessageModal,
        setErrorMessageModal,
        classes.borderWhite,
        classes.quickAccessIcon,
        classes.contentDialogTitle,
        handleLogout
      )}

      {
        <Portal>
          {registerReduxState?.isLoading ? (
            <Backdrop
              sx={{ color: "#0075C9", zIndex: 9999 }}
              open={registerReduxState?.isLoading}
            >
              <CircularProgress color="inherit" />
            </Backdrop>
          ) : null}
        </Portal>
      }
    </>
  );
};

export default Register;
